import 'swiper/css/effect-fade'

import {
  INFO_POPUP_TYPE,
  InfoPopup,
  isIosOrAndroid,
  useAccountContext
} from '@apeiron/temp'
import { styled, Typography } from '@mui/material'
import OkxWalletButton from '@src/components/wallet/buttons/OkxWalletButton'
import RoninWalletButton from '@src/components/wallet/buttons/RoninWalletButton'
import ENV_CONFIG from '@src/config'
import { FC, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const StyledInfoPopup = styled(InfoPopup)`
  background-color: #262829;
  border-radius: 6px;
  max-width: 400px;
  width: 95%;
  max-height: 250px;
  height: 100%;

  .Custom-Content {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    padding: 0px 50px 40px 50px;
    width: 100%;

    ${props => props.theme.breakpoints.down('res768')} {
      padding: 0px 20px 20px 20px;
    }
  }
`

const Header = styled(Typography)`
  font-weight: 300;
  text-align: center;
`

const MissWalletPopup: FC<Props> = () => {
  const { missWallet, wrongNetwork, setMissWallet, setWrongNetwork } =
    useAccountContext()

  const { t } = useTranslation()

  const [showPopup, setShowPopup] = useState(false)

  const handleOnClose = useCallback(() => {
    setShowPopup(false)
    setTimeout(() => {
      setMissWallet(null)
      setWrongNetwork(null)
    }, 500)
  }, [setMissWallet, setWrongNetwork])

  useEffect(() => {
    setShowPopup(!!missWallet)
  }, [missWallet, wrongNetwork])

  const handleRoninClick = useCallback(() => {
    if (isIosOrAndroid()) {
      location.href =
        'roninwallet://in_app_browser?url=' + encodeURIComponent(location.href)
    } else {
      window.open(ENV_CONFIG.EXTERNAL_URL.WALLET.RONIN.DOWNLOAD)
    }
  }, [])

  const handleOkxClick = useCallback(() => {
    if (isIosOrAndroid()) {
      const encodedUrl =
        'https://www.okx.com/download?deeplink=' +
        encodeURIComponent(
          'okx://wallet/dapp/url?dappUrl=' + encodeURIComponent(location.href)
        )

      window.location.href = encodedUrl
    } else {
      window.open(ENV_CONFIG.EXTERNAL_URL.WALLET.OKX.DOWNLOAD)
    }
  }, [])

  return (
    <StyledInfoPopup
      open={showPopup}
      type={INFO_POPUP_TYPE.BLACK}
      onClose={handleOnClose}
    >
      <Header>
        {t('wallet.miss_wallet_header', {
          context: isIosOrAndroid() ? 'mobile' : 'desktop'
        })}
      </Header>
      <RoninWalletButton onClick={handleRoninClick} />
      <OkxWalletButton onClick={handleOkxClick} />
    </StyledInfoPopup>
  )
}

type Props = {}

export default MissWalletPopup
